import * as React from "react";
import Tabs, { useTabs } from "../components/atoms/tab";
import WarningScreen from "../components/layout/withdraw/WarningScreen";
import { withTabContnet } from "../components/atoms/tab/withTabContent";
import Button from "../components/atoms/button";
import AppBar from "../components/atoms/appbar";
import WithdrawCompleteScreen from "../components/layout/withdraw/WithdrawCompleteScreen";
import { FormProvider, useForm } from "react-hook-form";
import WithDrawTelecomScreen from "../components/layout/withdraw/WithDrawTelecomScreen";
import type { LoginInput } from "../types/auth.types";
import { zodResolver } from "@hookform/resolvers/zod";
import { loginSchema } from "../lib/schemas/auth.schema";
import { useMutation } from "@tanstack/react-query";
import { withdraw } from "../@apis/v1/auth.service";
import { useAccessStore } from "../lib/store/useAccessStore";
import { resetUserSession } from "../@apis/queryClient";
import type { OnErrorResponse } from "../@apis/dto/response/common.response";
import { useModalStore } from "../lib/store/useModalStore";

export default function WithDraw() {
  const { clearAccess } = useAccessStore();
  const { openModal } = useModalStore();
  const [request, setRequest] = React.useState(false);

  const { currentTab, next } = useTabs(1);
  const WarningScreenTab = React.useMemo(
    () => withTabContnet(WarningScreen, {}),
    [],
  );
  const TelecomScreenTab = React.useMemo(
    () => withTabContnet(WithDrawTelecomScreen, {}),
    [],
  );
  const WithdrawCompleteScreenTab = React.useMemo(
    () => withTabContnet(WithdrawCompleteScreen, {}),
    [],
  );

  const methos = useForm<LoginInput>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      otp: "",
      mobileno: "",
    },
  });
  const { watch, getValues, setValue } = methos;

  const disabledButton = () => {
    const otp = watch("otp");
    if (!!otp && otp.toString().length == 6) return false;

    return true;
  };

  const confirmOTPMutation = useMutation({
    mutationFn: (form: LoginInput) => withdraw(form),
    onSuccess: (res) => {
      const { success, error } = res;
      if (success) {
        clearAccess();
        resetUserSession();
        next();
      } else {
        openModal("ALERT_DIALOG", {
          title: "에러",
          content:
            error?.code === "C003" ? "요청에 실패하였습니다." : error?.message,
        });
      }
    },
    onError: (err: OnErrorResponse) => {
      const { error } = err.response.data;
      openModal("ALERT_DIALOG", {
        title: "에러",
        content:
          error?.code === "C003" ? "요청에 실패하였습니다." : error?.message,
      });

      if (error?.code === "P117") {
        setValue("otp", "");
        setRequest(false);
      }
    },
  });

  return (
    <div className="flex flex-col">
      {currentTab != 3 && <AppBar backButton title="회원 탈퇴" />}
      <section className="px-[16px] flex flex-col justify-between min-h-[calc(100vh-56px)]">
        <div className="flex-1">
          <FormProvider {...methos}>
            <Tabs currentTab={currentTab}>
              <WarningScreenTab next={next} />
              <TelecomScreenTab request={request} setRequest={setRequest} />
              <WithdrawCompleteScreenTab />
            </Tabs>
          </FormProvider>
        </div>

        {currentTab == 2 && (
          <div className="pb-[15px]">
            <Button
              className="w-full"
              disabled={disabledButton()}
              variant={disabledButton() ? "disabled" : "black"}
              onClick={() => confirmOTPMutation.mutate(getValues())}
              label="탈퇴 완료"
            />
          </div>
        )}
      </section>
    </div>
  );
}
